document.addEventListener('DOMContentLoaded', function () {
  try {
    const wishlistList = JSON.parse(localStorage.getItem('wishlistItem')) || [];
    const count = Array.isArray(wishlistList) ? wishlistList.length : 0;

    document.querySelectorAll('[data-wishlist-count]').forEach(elem => {
      elem.textContent = count;
    });

    document.querySelectorAll('.wishlist-count-bubble').forEach(bubble => {
      bubble.style.display = count > 0 ? '' : 'none';
    });
  } catch (e) {
    // fallback seguro
    document.querySelectorAll('[data-wishlist-count]').forEach(elem => {
      elem.textContent = 0;
    });
  }
});
